module.exports = "/_next/static/images/BuildHighPerformance-3-d939c997c975494414b89d4e6d4153b5.webp";